<template>
  <v-menu
    location="top"
    :close-on-content-click="false"
    transition="slide-y-transition"
  >
    <template #activator="{ props }">
      <v-btn
        v-if="!mobile"
        v-tooltip:bottom="'Automatic Page Turning'"
        v-bind="props"
        variant="plain"
        :color="timerRunning ? 'accent' : 'primary'"
      >
        <v-icon icon="fa-sharp-duotone fa-stopwatch" />
        {{ timeLeft }}
      </v-btn>

      <v-btn
        v-else
        v-bind="props"
        :color="timerRunning ? 'accent' : 'primary'"
        prepend-icon="fa-sharp-duotone fa-stopwatch"
      >
        {{ timeLeft }} sec.
      </v-btn>
    </template>
    <v-card
      width="auto"
      theme="dark"
      class="mainpanel"
    >
      <v-card-actions>
        <v-btn
          v-tooltip:bottom="'Start Timer'"
          :disabled="timerRunning"
          icon="fa-sharp-duotone fa-play"
          @click="startTimer"
        />
        <v-btn
          v-tooltip:bottom="'Stop Timer'"
          :disabled="!timerRunning"
          icon="fa-sharp-duotone fa-stop"
          @click="stopTimer"
        />
        <v-divider
          vertical
          inset
        />
        <v-btn
          v-tooltip:bottom="'Decrease 10 secs'"
          icon="fa-sharp-duotone fa-chevrons-down"
          @click="changeSpeed(-10)"
        />

        <v-btn
          v-tooltip:bottom="'Decrease 1 sec'"
          icon="fa-sharp-duotone fa-chevron-down"
          @click="changeSpeed(-1)"
        />
        <span class="text-secondary">{{ timeValue }}</span>
        <v-btn
          v-tooltip:bottom="'Increase 1 sec'"
          icon="fa-sharp-duotone fa-chevron-up"
          @click="changeSpeed(1)"
        />
        <v-btn
          v-tooltip:bottom="'Increase 10 secs'"
          icon="fa-sharp-duotone fa-chevrons-up"
          @click="changeSpeed(10)"
        />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useDisplay } from "vuetify";

const { mobile } = useDisplay();

const timeLeft = ref(20);
const timeValue = ref(20);
const interval = ref<number | null>(null);

const timerRunning = ref(false);

const emit = defineEmits(['timeReached']);

function startTimer()
{
  timerRunning.value = true;
  timeLeft.value = timeValue.value;
  interval.value = window.setInterval(() => {
    if (timeLeft.value === 0) {
      if (interval.value !== null) clearInterval(interval.value);
    }
    timeLeft.value--;
  }, 1000);
}

function stopTimer()
{
  timerRunning.value = false;
  // clearInterval(interval.value);
  if (interval.value !== null) clearInterval(interval.value);
}

function changeSpeed(val: number) {
  if (timeValue.value + val > 0)
  {
    timeValue.value = timeValue.value + val;
  } else {
    timeValue.value = 1;
  }
}

watch(
  () => timeLeft.value,
  () => {
    if (timeLeft.value === 0 && timerRunning.value === true)
    {
      emit('timeReached');
      timeLeft.value = timeValue.value;
    }
  }
)


</script>

<style lang="scss">
.timer {
  position: fixed !important;
  z-index: 20;

}
</style>
